import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Panel, StatusBadge } from "@/components/common";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate, todayISO } from "@/lib/format";

export const FlaggedJobs = ({ total }) => {
  const navigate = useNavigate();
  const { data } = useFetch("/bookings", { flagged: "1", scope: "upcoming", today: todayISO() });
  const jobs = (data || []).filter((j) => !["Cancelled", "Refunded"].includes(j.status));
  return (
    <Panel title={<span className="inline-flex items-center gap-2"><AlertTriangle className="h-4 w-4 text-amber-600" /> Upcoming jobs missing information ({total})</span>}
      action={<button onClick={() => navigate("/bookings/flagged")} className="text-sm font-medium text-sky-700 hover:underline" data-testid="link-all-flagged">Fix them in one screen →</button>}>
      {jobs.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="flagged-empty">No upcoming jobs are missing information.</p>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="flagged-list">
          {jobs.slice(0, 12).map((j) => (
            <li key={j.id} onClick={() => navigate(`/bookings/${j.id}`)} className="flex cursor-pointer flex-wrap items-center gap-x-4 gap-y-1 py-2.5 hover:bg-amber-50/60" data-testid={`flagged-${j.id}`}>
              <span className="w-28 text-sm font-medium text-slate-800">{fmtDate(j.moving_date, "EEE d MMM")}</span>
              <span className="font-mono text-xs font-bold text-sky-700">{j.job_number}</span>
              <span className="min-w-[140px] font-medium">{j.customer_name}</span>
              <StatusBadge status={j.status} />
              <span className="ml-auto flex flex-wrap gap-1">{j.missing_info.map((f) => <span key={f} className="rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-semibold text-amber-900">{f}</span>)}</span>
            </li>
          ))}
          {jobs.length > 12 && <li className="pt-2 text-xs text-slate-500">+{jobs.length - 12} more upcoming.</li>}
        </ul>
      )}
    </Panel>
  );
};
